export default __webpack_public_path__ + "images/MH.02bc3f9.png";